module.exports = __webpack_public_path__ + "static/media/lidingshan_package.546ccc65.png";